import { createAuthClient } from 'better-auth/vue';
import { adminClient, organizationClient, twoFactorClient } from 'better-auth/client/plugins';

const baseURL = import.meta.env.VITE_API_URL ?? '';

/**
 * Better Auth Vue client. Mirrors the engine plugins:
 *   - twoFactorClient
 *   - organizationClient (account = organization)
 *   - adminClient        (super-admin createUser, listUsers, etc.)
 *
 * Public sign-up is disabled engine-side; the client deliberately does NOT
 * expose `signUp.email` from the UI surface (we just don't call it).
 */
export const authClient = createAuthClient({
  baseURL,
  plugins: [twoFactorClient(), organizationClient(), adminClient()],
});

export type AuthClient = typeof authClient;
